import { colors } from "@zapalacorp/tokens";

export interface IStyles {
  error?: boolean;
  disabled?: boolean;
}

interface ICssValues extends IStyles {
  defaultValue: string;
  disabledValue?: string;
}

export const cssAttributeValue = ({
  disabled,
  error,
  defaultValue,
  disabledValue,
}: ICssValues): string => {
  if (disabled) {
    return disabledValue ?? colors.gray800;
  }

  if (error) {
    return colors.error600;
  }

  return defaultValue;
};
